import { createFileRoute } from "@tanstack/react-router";
import { fallback, zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

import { DocumentTitle } from "@/components";
import { VoucherListPage, voucherListSortEnum } from "@/modules/voucher";
import { requireAuthAndPermission } from "@/utils";

const voucherListSearchSchema = z.object({
  q: fallback(z.string(), "").default(""),
  page: fallback(z.number(), 1).default(1),
  sort: fallback(voucherListSortEnum, "newest").default("newest")
});

export const Route = createFileRoute("/vouchers/")({
  validateSearch: zodValidator(voucherListSearchSchema),
  beforeLoad: requireAuthAndPermission,
  component: () => (
    <>
      <DocumentTitle
        title="Vouchers"
        description="Create and manage discount vouchers for your products."
      />
      <VoucherListPage />
    </>
  )
});
